import { ReactNode } from 'react';
import { useMyPlan } from '../hooks/use-seats';

interface PlanGuardProps {
  children: ReactNode;
  /** Shown instead of children when the check fails. */
  fallback?: ReactNode;
  /** 'has-plan' (default) shows children to people with a plan; 'no-plan' to people without one. */
  when?: 'has-plan' | 'no-plan';
}

/**
 * Shows children only when the signed-in person's plan matches `when`.
 * Same check as the chat page: no seat held (or NOPLAN) means no plan.
 */
export const PlanGuard = ({ children, fallback = null, when = 'has-plan' }: PlanGuardProps) => {
  const { hasPlan, isLoading } = useMyPlan();

  // Render nothing until we know, so guarded content never flashes in or out.
  if (isLoading) return null;

  const isAllowed = when === 'has-plan' ? hasPlan : !hasPlan;

  return <>{isAllowed ? children : fallback}</>;
};
